import 'angular';

import { downgradeComponent } from '@angular/upgrade/static';

import { BookingsApiSettingsComponent } from './bookings.api-settings.component';

angular.module('app-lite.bookings', [])
  .directive('worBookingsApiSettings', downgradeComponent({ component: BookingsApiSettingsComponent }));
